import React from 'react'
import LargeLinkTile from '../LargeLinkTile/LargeLinkTile'
import _ from 'lodash'

const LargeLinkTileWrapper = ({ entity, even }) => {
  return (
    <LargeLinkTile
      title={_.get(entity, 'fieldTitle')}
      text={_.get(entity, 'fieldText')}
      image={_.get(entity, 'fieldBackground.entity.fieldMediaImage.linkTileImage.image.childImageSharp')}
      url={_.get(entity, 'fieldMoreLink.url.path')}
      urlText={_.get(entity, 'fieldMoreLink.title')}
      linkLabel={_.get(entity, 'fieldMoreLinkLabel', null)}
      even={even}
    />
  )
}

export default LargeLinkTileWrapper
